"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geocodeAddress = void 0;
const determineZoomLevel_1 = require("./determineZoomLevel");
const geocodeAddress = (address) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const geocoder = new google.maps.Geocoder();
        const response = yield geocoder.geocode({ address });
        if (!response.results.length)
            return null;
        const top = response.results[0];
        const { lat, lng } = top.geometry.location.toJSON();
        const { zoom, bounds } = (0, determineZoomLevel_1.determineZoomLevel)(response.results);
        return { lat, lng, zoom, bounds, resolvedName: top.formatted_address };
    }
    catch (_a) {
        return null;
    }
});
exports.geocodeAddress = geocodeAddress;
